import type { z } from "zod";

import type {
  RtOperatedAssetCostKeys,
  RtOperatedAssetGroup,
  RtOperatedAssetItem,
  RtOperatedAssetRentKeys,
  RtOperatingCostKeys,
  RtOtherIncomeGroup,
  RtOtherIncomeItem,
  RtResidentialAreaKeys,
  RtResidentialCostKeys,
  RtResidentialDepositKeys,
  RtResidentialPriceKeys,
  RtResidentialSalesGroup,
  RtResidentialSalesItem,
  RtRevenueGroupBase,
  RtRevenueItemBase,
  RtSalesGroupBase,
} from "../runtypes/RtRevenueGroup.js";

export type ResidentialCostKeys = z.infer<typeof RtResidentialCostKeys>;
export type ResidentialDepositKeys = z.infer<typeof RtResidentialDepositKeys>;
export type ResidentialPriceKeys = z.infer<typeof RtResidentialPriceKeys>;
export type ResidentialAreaKeys = z.infer<typeof RtResidentialAreaKeys>;
export type OperatedAssetRentKeys = z.infer<typeof RtOperatedAssetRentKeys>;
export type OperatingCostKeys = z.infer<typeof RtOperatingCostKeys>;
export type OperatedAssetCostKeys = z.infer<typeof RtOperatedAssetCostKeys>;

export type ShapeRevenueItemBase = z.infer<typeof RtRevenueItemBase>;
export type ShapeRevenueGroupBase = z.infer<typeof RtRevenueGroupBase>;

export type ShapeResidentialSalesItem = z.infer<typeof RtResidentialSalesItem>;

export type ShapeSalesGroupBase = z.infer<typeof RtSalesGroupBase>;
export type ShapeResidentialSalesGroup = z.infer<
  typeof RtResidentialSalesGroup
>;

export type ShapeOperatedAssetItem = z.infer<typeof RtOperatedAssetItem>;
export type ShapeOperatedAssetGroup = z.infer<typeof RtOperatedAssetGroup>;

export type ShapeOtherIncomeItem = z.infer<typeof RtOtherIncomeItem>;
export type ShapeOtherIncomeGroup = z.infer<typeof RtOtherIncomeGroup>;

export type ShapeRevenueGroup =
  | ShapeResidentialSalesGroup
  | ShapeOperatedAssetGroup
  | ShapeOtherIncomeGroup;
export type RevenueGroupCategories = ShapeRevenueGroup["category"];

export const otherIncomeGroupPredicate = <
  Group extends Pick<ShapeRevenueGroup, "category">,
>(
  group: Group,
): group is Extract<
  Group,
  {
    category: "other";
  }
> => group.category === "other";

export const salesGroupPredicate = <
  Group extends Pick<ShapeRevenueGroup, "category">,
>(
  group: Group,
): group is Exclude<
  Group,
  {
    category: "other";
  }
> => !otherIncomeGroupPredicate(group);

export const operatedAssetGroupPredicate = <
  Group extends Pick<ShapeRevenueGroup, "category">,
>(
  group: Group,
): group is Extract<
  Group,
  {
    category: "operated";
  }
> => group.category === "operated";
